import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=5d2ca630"
import script from "./PartnerDetail.vue?vue&type=script&lang=js"
export * from "./PartnerDetail.vue?vue&type=script&lang=js"
import style0 from "./PartnerDetail.vue?vue&type=style&index=0&id=5d2ca630&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports